import { AxiosInstance, AxiosResponse } from 'axios';
import { AxiosClient, AxiosUtils } from 'api/AxiosClient/AxiosClient';
import { config } from 'config';
import * as Sentry from '@sentry/react';
import { SERVICE_DOWN, TOO_MUCH_REQUESTS } from 'api/errors';
import { LINE_TYPES } from 'types';

class PhoneValidation {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = AxiosClient.get({
      baseURL: config.URL_PHONE_VALIDATION,
    });
  }

  public async requestCode(phoneNumber: string, customId: string, lineType: number): Promise<string> {
    return this.client
      .post<any>(
        'v1/code-request',
        {
          phone: phoneNumber,
          method: lineType === LINE_TYPES.FIXED_LINE ? 'tts' : 'sms',
          customId,
        },
        {
          headers: AxiosClient.getAuthorizationHeader(),
        },
      )
      .then(r => r.data.requestId)
      .catch(r => {
        Sentry.captureException(r, {
          tags: {
            api: 'PhoneValidator',
            endpoint: 'requestCode',
            ...AxiosUtils.enrichTags(r),
          },
        });
        if (r.response) {
          const response: AxiosResponse<any> = r.response;
          if (r.response?.data?.error === 'Exceeded quota') {
            return Promise.reject({ message: TOO_MUCH_REQUESTS });
          }
          return Promise.reject({ message: response.data.error });
        }
        return Promise.reject({ message: SERVICE_DOWN });
      });
  }

  public async validateCode(requestId: string, code: string): Promise<boolean> {
    return this.client
      .post<any>(
        `v1/code-request/${requestId}/validation`,
        { code },
        {
          headers: AxiosClient.getAuthorizationHeader(),
        },
      )
      .then(r => r.data.isValid)
      .catch(r => {
        Sentry.captureException(r, {
          tags: {
            api: 'PhoneValidator',
            endpoint: 'validateCode',
            ...AxiosUtils.enrichTags(r),
          },
        });
        if (r.response) {
          const response: AxiosResponse<any> = r.response;
          if (response?.data?.error === 'Exceeded attempts') {
            return Promise.reject({ message: TOO_MUCH_REQUESTS });
          }
          return Promise.reject({ message: response.data.error });
        }
        return Promise.reject({ message: SERVICE_DOWN });
      });
  }
}

export const PhoneValidationService = new PhoneValidation();
